import { AnswerContent as TAnswerContent } from "@/schema/console/evaluation-reports/AnswerContent";
import AnswerRadioGroup from "@/src/console/(auth)/_components/EvaluationReport/AnswerContent/AnswerRadioGroup";
import AssessorCheckItem from "@/src/console/(auth)/_components/EvaluationReport/AnswerContent/AssessorCheckItem";
import { useTranslation } from "react-i18next";

interface AnswerContentProps {
  index: number;
  answerContent: TAnswerContent;
}

function AnswerContent({
  index,
  answerContent: { content, extension_note, answer_evaluations, answer },
}: AnswerContentProps) {
  const { t } = useTranslation();
  return (
    <div className=" flex flex-col gap-5 p-5">
      <div className=" text-base font-medium">
        {index + 1}、{content}
      </div>
      <AnswerRadioGroup answer={answer} />
      <div className="text-cool-gray-500">
        {extension_note
          ? `${t("supplemental-information")} : ${extension_note}`
          : t("no-supplemental-information")}
      </div>
      <div className=" flex flex-col gap-4 p-4 rounded-md bg-cool-gray-50">
        <p className=" text-sm font-medium text-cool-gray-700">
          {t("assessor-check-items")}
        </p>
        {answer_evaluations.map((answerEvaluation, index) => (
          <AssessorCheckItem
            key={answerEvaluation.id}
            index={index}
            answerEvaluation={answerEvaluation}
          />
        ))}
      </div>
    </div>
  );
}

export default AnswerContent;
